import { render, staticRenderFns } from "./QuestionFormWorkflow.vue?vue&type=template&id=45762bb6&scoped=true"
import script from "./QuestionFormWorkflow.vue?vue&type=script&lang=js"
export * from "./QuestionFormWorkflow.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormWorkflow.vue?vue&type=style&index=0&id=45762bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45762bb6",
  null
  
)

export default component.exports